/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_timer_pomodoro_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A free Pomodoro timer for focused work. Run a 25-minute focus session with an alarm, then take a break. No signup, works in your browser.`)
};

const es_timer_pomodoro_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador Pomodoro gratis para el trabajo enfocado. Ejecuta una sesión de 25 minutos con alarma y luego toma un descanso. Sin registro.`)
};

const de_timer_pomodoro_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein kostenloser Pomodoro-Timer für fokussiertes Arbeiten. Absolviere eine 25-minütige Fokus-Session mit Alarm und mach dann eine Pause. Keine Anmeldung, läuft im Browser.`)
};

const nl_timer_pomodoro_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een gratis Pomodoro-timer voor geconcentreerd werken. Doorloop een focussessie van 25 minuten met alarm en neem daarna pauze. Geen aanmelding, werkt in je browser.`)
};

const fr_timer_pomodoro_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un minuteur Pomodoro gratuit pour un travail concentré. Lancez une session de concentration de 25 minutes avec alarme, puis faites une pause. Sans inscription, dans votre navigateur.`)
};

const it_timer_pomodoro_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un timer Pomodoro gratuito per il lavoro concentrato. Avvia una sessione di 25 minuti con allarme, poi fai una pausa. Nessuna registrazione, funziona nel browser.`)
};

const pt_br2_timer_pomodoro_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temporizador Pomodoro grátis para foco. Sessão de 25 minutos com alarme, depois uma pausa. Sem cadastro, funciona no navegador.`)
};

const pt_timer_pomodoro_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um temporizador Pomodoro gratuito para trabalho focado. Faça uma sessão de foco de 25 minutos com alarme e depois faça uma pausa. Sem registo, funciona no navegador.`)
};

const ja_timer_pomodoro_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中して作業するための無料ポモドーロタイマー。アラーム付きの25分集中セッションを実行し、その後休憩を取りましょう。登録不要でブラウザ上で動作します。`)
};

const zh_timer_pomodoro_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费番茄钟，助力专注工作。运行25分钟专注时段，闹铃提醒后休息一下。无需注册，可在浏览器中使用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const timer_pomodoro_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.timer_pomodoro_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("timer_pomodoro_meta_description", locale)
	if (locale === "en") return en_timer_pomodoro_meta_description(inputs)
	if (locale === "es") return es_timer_pomodoro_meta_description(inputs)
	if (locale === "de") return de_timer_pomodoro_meta_description(inputs)
	if (locale === "nl") return nl_timer_pomodoro_meta_description(inputs)
	if (locale === "fr") return fr_timer_pomodoro_meta_description(inputs)
	if (locale === "it") return it_timer_pomodoro_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_timer_pomodoro_meta_description(inputs)
	if (locale === "pt") return pt_timer_pomodoro_meta_description(inputs)
	if (locale === "ja") return ja_timer_pomodoro_meta_description(inputs)
	return zh_timer_pomodoro_meta_description(inputs)
};